import request from "../../../helpers/request";

export const getPontosMonitoriaByLoja = async (
  idLoja: string,
  idRegional: string,
  apiKey: string,
) => {
  try {
    console.log(
      "Fetching pontos monitoria for loja:",
      idLoja,
      "and regional:",
      idRegional,
    );

    const url = `${process.env.REACT_APP_API}/Hub/GrupoMonitor/PtosMonitor/${idLoja}`;
    let result;
    if (apiKey) {
      result = await request({ url, apiKey });
    } else {
      result = await request({ url });
    }

    return result.data;
  } catch (error) {
    console.error("Error fetching pontos monitoria:", error);
    throw error;
  }
};

export const getPontosMonitoriaByRegional = async (
  idRegional: string,
  apiKey: string,
) => {
  try {
    const url = `${process.env.REACT_APP_API}/Hub/GrupoMonitor/PtosMonitorRegional/${idRegional}`;
    const result = apiKey
      ? await request({ url, apiKey })
      : await request({ url });
    return result.data;
  } catch (error) {
    console.error("Error fetching pontos monitoria regional:", error);
    throw error;
  }
};
